import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Plus, Settings, Shield } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const BottomNav = () => {
  const { isAdmin } = useAuth();

  const navItems = [
    {
      path: '/dashboard',
      label: 'Accueil',
      icon: LayoutDashboard
    },
    {
      path: '/documents',
      label: 'Archives',
      icon: FileText
    },
    {
      path: '/documents/add',
      label: 'Ajouter',
      icon: Plus,
      isSpecial: true
    },
    ...(isAdmin() ? [{
      path: '/admin',
      label: 'Admin',
      icon: Shield
    }] : []),
    {
      path: '/parametres',
      label: 'Profil',
      icon: Settings
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-bottom z-50">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;

          if (item.isSpecial) {
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className="flex flex-col items-center justify-center"
              >
                <div className="w-14 h-14 -mt-8 bg-primary-600 rounded-full flex items-center justify-center shadow-lg">
                  <Icon size={24} className="text-white" />
                </div>
                <span className="text-xs font-medium text-gray-600 mt-1">{item.label}</span>
              </NavLink>
            );
          }

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center min-w-[60px] py-2 transition-colors ${
                  isActive ? 'text-primary-600' : 'text-gray-500'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={24} className={isActive ? 'text-primary-600' : 'text-gray-400'} />
                  <span className={`text-xs mt-1 font-medium ${isActive ? 'text-primary-600' : 'text-gray-500'}`}>
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
